import { render, staticRenderFns } from "./customerOrderStatus.vue?vue&type=template&id=0ea88f00&scoped=true"
import script from "./customerOrderStatus.vue?vue&type=script&lang=js"
export * from "./customerOrderStatus.vue?vue&type=script&lang=js"
import style0 from "./customerOrderStatus.vue?vue&type=style&index=0&id=0ea88f00&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea88f00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea88f00')) {
      api.createRecord('0ea88f00', component.options)
    } else {
      api.reload('0ea88f00', component.options)
    }
    module.hot.accept("./customerOrderStatus.vue?vue&type=template&id=0ea88f00&scoped=true", function () {
      api.rerender('0ea88f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/waybillKanbanBoard/component/customerOrderStatus.vue"
export default component.exports